import styled from 'styled-components'
import { ColoredDot } from 'styling/GlobalStyles'
import { tokens } from 'styling/tokens'

export const SubtitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.5rem;
`

export const HandoverGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  align-items: start;
  margin-top: 1rem;

  @media (max-width: 70rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const SpanFull = styled.div`
  grid-column: 1 / -1;
`

export const DeltaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 1rem;
`

export const DeltaCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const DeltaValue = styled.span`
  font-size: ${tokens.font.h2};
  font-weight: 700;
  color: ${tokens.accent.onDark};
`

export const TaskMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 70rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const MachineDownRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
`

export const MachineDownMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
`

export const FieldLabel = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${tokens.text.muted};
`

export const SeverityRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`

export const UtilList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const RiskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const RiskRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.status.warning.bg};
`

export const RiskDot = styled(ColoredDot)`
  min-width: 0.5rem;
  max-width: 0.5rem;
  min-height: 0.5rem;
  max-height: 0.5rem;
  margin-top: 0.375rem;
  box-shadow: 0 0 8px ${(props) => props.color};
`

export const RequestCode = styled.span`
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const SignOffActions = styled.div`
  display: flex;
`

export const SignOffConfirmed = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 1rem;
  border: 1px solid ${tokens.status.success.fg};
  border-radius: ${tokens.radius.control};
  background: ${tokens.status.success.bg};
`
